import { render, staticRenderFns } from "./ReportFittingInfo.vue?vue&type=template&id=53523d82&scoped=true"
import script from "./ReportFittingInfo.vue?vue&type=script&lang=js"
export * from "./ReportFittingInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53523d82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53523d82')) {
      api.createRecord('53523d82', component.options)
    } else {
      api.reload('53523d82', component.options)
    }
    module.hot.accept("./ReportFittingInfo.vue?vue&type=template&id=53523d82&scoped=true", function () {
      api.rerender('53523d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Report/ReportFittingInfo/ReportFittingInfo.vue"
export default component.exports